var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import Dashboard from '../Dashboard';
import { WidgetDrawer, WidgetDrawerType } from '../widget-drawer/WidgetDrawer';
const WidgetPanel = ({ onWidgetPropsChange, isEditing, onRegisterOpenDrawer, columns = 12, orientation = 'vertical', rows = 3, childWidgets = [], childLayouts = {}, }) => {
    const [showWidgetDrawer, setShowWidgetDrawer] = useState(false);
    // Register the open-drawer function with the parent overlay's plus button
    useEffect(() => {
        onRegisterOpenDrawer === null || onRegisterOpenDrawer === void 0 ? void 0 : onRegisterOpenDrawer(() => setShowWidgetDrawer(true));
    }, [onRegisterOpenDrawer]);
    // Single fixed-column breakpoint — panel width determined by its parent cell, not the viewport
    const panelBreakpoints = useMemo(() => ({
        default: { width: 0, columns, label: 'Default' }
    }), [columns]);
    // Seed with "default" key and pre-normalize to orientation constraints to avoid first-render flash
    const normalizedLayouts = useMemo(() => {
        const base = Object.keys(childLayouts).length === 0 ? { default: [] } : childLayouts;
        if (orientation === 'vertical') {
            return Object.fromEntries(Object.entries(base).map(([bp, items]) => [bp, (items || []).map(i => (Object.assign(Object.assign({}, i), { w: columns, x: 0 })))]));
        }
        if (orientation === 'horizontal') {
            const r = rows !== null && rows !== void 0 ? rows : 3;
            return Object.fromEntries(Object.entries(base).map(([bp, items]) => [bp, (items || []).map(i => (Object.assign(Object.assign({}, i), { h: Math.min(i.h, r), y: 0 })))]));
        }
        return base;
    }, [childLayouts, orientation, columns, rows]);
    const handleChildSave = useCallback((updatedWidgets, updatedLayouts) => __awaiter(void 0, void 0, void 0, function* () {
        onWidgetPropsChange({
            childWidgets: updatedWidgets,
            childLayouts: updatedLayouts
        });
        return true;
    }), [onWidgetPropsChange]);
    const handleWidgetDrawerChange = useCallback((event) => {
        if (event.widgets && event.layouts) {
            handleChildSave(event.widgets, event.layouts);
        }
        return true;
    }, [handleChildSave]);
    return (_jsxs("div", { className: classNames('uxpcore_widgetpanel', `uxpcore_widgetpanel--${orientation}`, { 'uxpcore_widgetpanel--editing': isEditing }), children: [_jsx("div", { className: "uxpcore_widgetpanel__body", children: _jsx(Dashboard, { widgets: childWidgets, layouts: normalizedLayouts, isEditing: isEditing, onSave: handleChildSave, breakpoints: panelBreakpoints, breakpointOverride: "default", showSpacerWidget: isEditing && orientation === 'vertical', overlayMode: false, allowFreePositioning: false, allowOverlap: false, isBounded: false, margin: [6, 6], padding: [6, 6], disableOverrideDimensions: true, orientation: orientation, rows: rows, emptyPlaceholder: {
                        show: false
                    } }) }), _jsx(WidgetDrawer, { show: showWidgetDrawer, onClose: () => setShowWidgetDrawer(false), widgets: childWidgets, layouts: normalizedLayouts, maxColumns: columns, onChange: handleWidgetDrawerChange, config: { mode: 'multi', showTypeFilter: false, defaultType: WidgetDrawerType.Widgets }, orientation: orientation })] }));
};
export default WidgetPanel;
